// src/App.js

import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

// Import Layout Components
import Header from './components/Header';
import Footer from './components/Footer';

// Import Pages/Sections
import AboutUs from './components/AboutUs';
import HeroBanner from './components/HeroBanner';
import ApplySection from './components/ApplySection';
import TrustedBy from './components/TrustedBy';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Blog from './components/Blog';
import ForSchools from './components/ForSchools';
import ScrollToTopButton from './components/ScrollToTopButton';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import ShareStorySection from './components/ShareStorySection';
import AdsApplySection from './components/AdsApplySection'; 

// Import Admin Components
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';

// Define the Home Page Component
const Home = () => (
  <>
    <HeroBanner />
    <main className="bg-mesh">
        <ApplySection />
        <TrustedBy />
        <HowItWorks />
        <Testimonials />
        <ShareStorySection />
        <FAQ />
    </main>
  </>
);

// Layout for Main Website (Header + Footer)
const MainLayout = ({ children }) => (
    <div className="text-slate-900 overflow-x-hidden">
        <Header />
        {children}
        <Footer />
         <ScrollToTopButton />
    </div>
);

function App() {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollToId) {
      const targetElement = document.getElementById(location.state.scrollToId);
      if (targetElement) {
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]); 

  // Check if current route is an Admin route
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
        {isAdminRoute ? (
            // ADMIN ROUTES (No Header/Footer)
            <Routes>
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
        ) : (
            // PUBLIC ROUTES (With Header/Footer)
            <MainLayout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/aboutus" element={<AboutUs />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/for-schools" element={<ForSchools />} />
                    <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
                      <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
                      <Route path="/apply-now" element={<AdsApplySection />} />
                </Routes>
            </MainLayout>
        )}
    </>
  );
}

export default App;